import InfluencerDetail from "@/Component/Common/InfluencerDetail";

const InfluencerDetailPage = async ({ params }: { params: Promise<{ slug: string | string[] }>; }) => {
    const resolvedParams = await params;
    const slug = Array.isArray(resolvedParams.slug) ? resolvedParams.slug[0] : resolvedParams.slug;

    return (
        <InfluencerDetail slug={slug} />
    )
}

export default InfluencerDetailPage
